import { useAtom } from 'jotai';

import { isScheduleDrawerOpenAtom } from '../store/scheduleDrawer.js';

export const useScheduleDrawer = () => {
  const [isOpen, setIsOpen] = useAtom(isScheduleDrawerOpenAtom);

  const toggle = () => setIsOpen((prev) => !prev);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return { isOpen, toggle, open, close };
};
